"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTeamStencil = exports.teamStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.teamStencilDefinition = {
    view: {
        label: 'Team',
        category: 'group',
        group: 'Persons & Groups',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'title',
                    'subheading',
                    'teaser',
                    'bio',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'uri-title',
                            'url',
                            'featured-media',
                            'featured-video',
                            'backdrop-media',
                            'logos',
                        ],
                    },
                    {
                        name: 'Hard facts',
                        items: [
                            'team-quote',
                            'year',
                            'location-of-nationality',
                            'team-leader',
                            'participating-disciplines',
                        ],
                    },
                    {
                        name: 'Soft facts',
                        items: ['soft-facts'],
                    },
                    {
                        name: 'Track records',
                        items: ['track-records'],
                    },
                    {
                        name: 'Social links',
                        items: ['social-links', 'website'],
                    },
                    {
                        name: 'Settings',
                        items: ['search-terms', 'standalone'],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'related-content',
                ],
            },
        ],
        previewConfiguration: {
            hasPagePreview: true,
            hasFeatureCardPreview: true,
        },
    },
    content: {
        [properties_1.backdropMediaPropertyDefinition.name]: properties_1.backdropMediaPropertyDefinition,
        [properties_1.bioPropertyDefinition.name]: properties_1.bioPropertyDefinition,
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.disciplinesPropertyDefinition.name]: {
            ...properties_1.disciplinesPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: ['discipline'],
                },
            ],
        },
        [properties_1.featuredMediaPropertyDefinition.name]: properties_1.featuredMediaPropertyDefinition,
        [properties_1.featuredTitlePropertyDefinition.name]: properties_1.featuredTitlePropertyDefinition,
        [properties_1.featuredVideoPropertyDefinition.name]: properties_1.featuredVideoPropertyDefinition,
        [properties_1.headerMediaPropertyDefinition.name]: {
            ...properties_1.headerMediaPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: [
                        'image',
                        'video',
                        'episode-video',
                        'film',
                        'recap-video',
                        'trailer-video',
                        'video-channel',
                    ],
                },
            ],
        },
        [properties_1.locationOfNationalityPropertyDefinition.name]: {
            ...properties_1.locationOfNationalityPropertyDefinition,
            view: { label: 'Country of origin' },
        },
        [properties_1.logosPropertyDefinition.name]: {
            ...properties_1.logosPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: ['image'],
                },
            ],
        },
        [properties_1.participatingDisciplinesPropertyDefinition.name]: properties_1.participatingDisciplinesPropertyDefinition,
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.teamQuotePropertyDefinition.name]: properties_1.teamQuotePropertyDefinition,
        [properties_1.relatedContentPropertyDefinition.name]: properties_1.relatedContentPropertyDefinition,
        [properties_1.searchTermsPropertyDefinition.name]: properties_1.searchTermsPropertyDefinition,
        [properties_1.seoTitlePropertyDefinition.name]: properties_1.seoTitlePropertyDefinition,
        [properties_1.socialLinksPropertyDefinition.name]: properties_1.socialLinksPropertyDefinition,
        [properties_1.socialTitlePropertyDefinition.name]: properties_1.socialTitlePropertyDefinition,
        [properties_1.softFactsPropertyDefinition.name]: properties_1.softFactsPropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        [properties_1.subheadingPropertyDefinition.name]: properties_1.subheadingPropertyDefinition,
        [properties_1.tagEventSeriesPropertyDefinition.name]: properties_1.tagEventSeriesPropertyDefinition,
        [properties_1.tagEventsPropertyDefinition.name]: properties_1.tagEventsPropertyDefinition,
        [properties_1.tagPersonsPropertyDefinition.name]: properties_1.tagPersonsPropertyDefinition,
        [properties_1.teamLeaderPropertyDefinition.name]: properties_1.teamLeaderPropertyDefinition,
        [properties_1.teaserPropertyDefinition.name]: properties_1.teaserPropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.trackRecordsPropertyDefinition.name]: properties_1.trackRecordsPropertyDefinition,
        [properties_1.uriTitlePropertyDefinition.name]: properties_1.uriTitlePropertyDefinition,
        [properties_1.urlPropertyDefinition.name]: properties_1.urlPropertyDefinition,
        [properties_1.websitePropertyDefinition.name]: properties_1.websitePropertyDefinition,
        [properties_1.yearPropertyDefinition.name]: {
            ...properties_1.yearPropertyDefinition,
            view: { label: 'Year of foundation' },
            constraints: [
                {
                    name: 'max',
                    argument: 2100,
                },
                {
                    name: 'min',
                    argument: 1700,
                },
            ],
        },
    },
    localizations: [],
    roles: ['taxonomy-manager'],
    spaces: [
        'alinghi',
        'batalla',
        'brand-building-events',
        'global',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'redbull_com',
        'redbull-powertrains',
        'redbull-racing',
        'redbulletin',
        'redbullmusic',
        'wingfinder',
    ],
    name: 'team',
};
const isTeamStencil = (stencil) => {
    return stencil.name === exports.teamStencilDefinition.name;
};
exports.isTeamStencil = isTeamStencil;
//# sourceMappingURL=data:application/json;base64,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